// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__325lk","col":"styles_col__1qc1G"};